import { SET_LAST_NAME } from 'actions';

export function setLastName(lastName: string) {
  return { lastName, type: SET_LAST_NAME };
}
